import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps, Space } from 'antd';
import React from 'react';

type Props<T> = {
	className?: string;
	label: React.ReactNode;
	title?: string;
	items: MenuProps['items'];
	disabled?: boolean;
	id?: string;
	overlayClassName?: string;
	icon?: React.ReactNode;
	iconPosition?: 'start' | 'end';
	labelIcon?: React.ReactNode;
};

const DropdownMenu = <T extends object | string | number>({
	className,
	items,
	label,
	disabled,
	title,
	id,
	overlayClassName,
	icon,
	iconPosition,
	labelIcon,
}: Props<T>) => {
	return (
		<Dropdown className={className} menu={{ items }} disabled={disabled} overlayStyle={{ width: 'max-content' }} overlayClassName={overlayClassName}>
			<Button id={id} icon={icon} iconPosition={iconPosition || 'start'} title={title}>
				<Space>
					{label} {labelIcon || <DownOutlined />}
				</Space>
			</Button>
		</Dropdown>
	);
};

export { DropdownMenu };
